import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './slice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // uses localStorage
// export const store = configureStore({
//     reducer: {
//         redux: counterReducer,
//     },
// });

// import counterReducer from './slice'; // your reducer

import { combineReducers } from 'redux';
// Combine your reducers (only one in this case)
const rootReducer = combineReducers({
    redux: counterReducer,
});

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['redux'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
    devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);
